// FETCH ALL STOCK FROM TEAM MASTER
export const FETCH_ALL_INFORMATION_REQUEST = 'FETCH_ALL_INFORMATION_REQUEST';
export const FETCH_ALL_INFORMATION_SUCCESS = 'FETCH_ALL_INFORMATION_SUCCESS';
export const FETCH_ALL_INFORMATION_FAILURE = 'FETCH_ALL_INFORMATION_FAILURE';
